export default __webpack_public_path__ + "static/media/elephant@2x.a0e0807f.png";